import { EntityType } from "@mapmycustomers/shared/enum";

import EntityTypesSupportedInNoContactIn from "@app/types/dashboard/cards/noContactIn/EntityTypesSupportedInNoContactIn";

export const NO_CONTACT_IN_ENTITY_TYPES: EntityTypesSupportedInNoContactIn[] = [
  EntityType.COMPANY,
  EntityType.PERSON,
  EntityType.DEAL,
] as const;
